import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../components/Button';
import api from '../services/api';

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/password-reset/request', { username: email });
    } catch {
      // Always show success to prevent email enumeration
    } finally {
      setLoading(false);
      setSubmitted(true);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.header}>
          <h1 style={styles.title}>Nephros</h1>
          <p style={styles.subtitle}>CKD Care Coordination</p>
        </div>

        {submitted ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <p style={styles.successText}>
              If that email address exists in our system, a password reset link has been sent to that address.
            </p>
            <p style={{ ...styles.successText, marginBottom: 0 }}>
              Check your inbox and follow the link to set a new password. The link expires in 24 hours.
            </p>
            <Button onClick={() => navigate('/login')} style={{ width: '100%', marginTop: '8px' }}>
              Back to Login
            </Button>
          </div>
        ) : (
          <div>
            <p style={styles.instructionText}>
              Enter your email address and we'll send a password reset link to that address.
            </p>
            <form onSubmit={handleSubmit} style={styles.form}>
              <div style={styles.fieldGroup}>
                <label style={styles.label} htmlFor="email">Email</label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  style={styles.input}
                  autoComplete="email"
                  autoFocus
                  required
                />
              </div>
              <Button type="submit" disabled={loading} style={{ width: '100%', marginTop: '4px' }}>
                {loading ? 'Sending...' : 'Send Reset Link'}
              </Button>
            </form>
            <div style={styles.footer}>
              <Button variant="ghost" onClick={() => navigate('/login')}>
                Back to Login
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

const styles = {
  container: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'var(--color-bg-page)', fontFamily: 'var(--font-family-base)' },
  card: { backgroundColor: 'var(--color-bg-card)', borderRadius: 'var(--radius-md)', boxShadow: 'var(--shadow-md)', padding: '48px', width: '100%', maxWidth: '400px' },
  header: { textAlign: 'center', marginBottom: '32px' },
  title: { fontSize: '28px', fontWeight: 'var(--font-weight-semibold)', color: 'var(--color-nav)', margin: '0 0 4px 0', letterSpacing: '-0.5px', fontFamily: 'var(--font-family-base)' },
  subtitle: { fontSize: 'var(--font-size-sm)', color: 'var(--color-text-muted)', margin: 0, fontFamily: 'var(--font-family-base)' },
  instructionText: { fontSize: 'var(--font-size-sm)', color: 'var(--color-text-secondary)', marginBottom: '24px', lineHeight: '1.5', fontFamily: 'var(--font-family-base)' },
  successText: { fontSize: 'var(--font-size-sm)', color: 'var(--color-text-secondary)', marginBottom: '16px', lineHeight: '1.5', fontFamily: 'var(--font-family-base)' },
  form: { display: 'flex', flexDirection: 'column', gap: '20px' },
  fieldGroup: { display: 'flex', flexDirection: 'column', gap: '6px' },
  label: { fontSize: '13px', fontWeight: 'var(--font-weight-medium)', color: 'var(--color-text-secondary)', fontFamily: 'var(--font-family-base)' },
  input: { padding: '10px 12px', border: '1px solid var(--color-border)', borderRadius: 'var(--radius-sm)', fontSize: 'var(--font-size-sm)', color: 'var(--color-text-primary)', outline: 'none', fontFamily: 'var(--font-family-base)' },
  footer: { textAlign: 'center', marginTop: '24px' },
};